import { environment } from '@env/environment';

export const PLATFORM_ADMIN = environment.platformAdminADgroup;
